const PREVIEW_TRIAL_BANNER_EXCLUDED_PATHS = new Set([
    '/pricing',
    '/ai-connections',
    '/trial',
    '/trial/preview',
    '/early-user-offer',
    '/checkout',
]);

export function canShowPreviewTrialBanner(pathname: string | null | undefined): boolean {
    if (
        !pathname
        || PREVIEW_TRIAL_BANNER_EXCLUDED_PATHS.has(pathname)
        || pathname.startsWith('/checkout/')
        || pathname.startsWith('/oauth/')
    ) {
        return false;
    }

    return true;
}
